/**
 * Ryan O'Dowd
 * 2024-12-02
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  return {
    container: {
      padding: 8,
      paddingLeft: 10,
      backgroundColor: isDarkMode ? colors.primaryDark : colors.primary, // @TODO: light mode should look better
    },
    title: {
      fontSize: globalScale * 20,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
      textTransform: 'capitalize',
    },
  };
};

export default getStyles;
